module.exports = __webpack_public_path__ + "img/heart_18_bj.80ef7359.png";